import React from "react"
import Register from "../../molecules/register/register"
import "./content.scss"

const Content = props => {
  return (
    <div className="f-Content">
      <Register mobile={props.mobile} setModal={props.setModal} />
    </div>
  )
}

export default Content
